import React from "react";
import { Link } from "react-router-dom";
import PolicyPage, { POLICY_ADDRESS, PolicyEmail } from "./PolicyPage";

function Delivery() {
  return (
    <PolicyPage
      title="Shipping and delivery policy"
      intro="This policy explains order preparation, delivery estimates, international charges, tracking, delays, and problems in transit."
    >
      <h2>Order processing</h2>
      <p>
        Orders are prepared after payment is authorized and any necessary
        verification is complete. A processing estimate is separate from a
        carrier’s transit estimate. Orders placed on weekends or holidays may
        begin processing on the next business day.
      </p>

      <h2>Destinations, methods, and charges</h2>
      <p>
        Available destinations, methods, shipping charges, and any delivery
        estimate are those presented or confirmed for your order. Not every
        method is available to every address. We may contact you if a carrier
        cannot service the address or if additional information is required.
      </p>

      <h2>Delivery estimates</h2>
      <p>
        Delivery dates are estimates unless expressly stated as guaranteed.
        Customs review, severe weather, carrier disruption, remote-area
        service, peak demand, and events outside reasonable control can affect
        transit. If we cannot ship within the promised or legally required time,
        we will provide the notice, choice to accept a revised date, and
        cancellation or refund required by applicable law.
      </p>

      <h2>Address accuracy and changes</h2>
      <p>
        You are responsible for providing a complete, accurate, deliverable
        address. Email us promptly if a correction is needed. We cannot promise
        a change after packing or dispatch. A carrier-requested redirect may
        create an additional charge or affect delivery protections.
      </p>

      <h2>Tracking and split shipments</h2>
      <p>
        Tracking will be provided when the selected service supports it. An
        order may arrive in more than one parcel; when that happens, separate
        tracking or delivery times may apply without increasing the confirmed
        merchandise total.
      </p>

      <h2>Customs, duties, and import restrictions</h2>
      <p>
        Unless the order expressly states that import charges are included, the
        recipient is responsible for customs duties, import taxes, brokerage,
        and destination fees. You are responsible for checking local import
        restrictions before ordering. We will not intentionally misstate value,
        contents, or gift status on customs documents.
      </p>

      <h2>Failed, refused, or unclaimed delivery</h2>
      <p>
        If a parcel is returned because an address was incorrect, delivery was
        refused, the parcel was unclaimed, or a destination charge was unpaid,
        we will contact you after the parcel is returned. Any reshipment or
        refund will take account of the item’s condition and recoverable costs,
        except where the failure resulted from our error or applicable law
        provides otherwise.
      </p>

      <h2>Loss, damage, or missing contents</h2>
      <p>
        Contact us promptly with your order number, a description, and clear
        photos of the item, shipping label, parcel, and packaging. Keep all
        packaging until the review is complete. We may ask you to cooperate
        with a carrier investigation, but this does not reduce rights you have
        against the seller under applicable law.
      </p>

      <h2>Contact</h2>
      <p>
        Email <PolicyEmail subject="Shipping or delivery question" /> for help.
        For cancellations before dispatch, see the
        <Link to="/orders"> Order and Cancellation Policy</Link>.
      </p>
      <p><strong>Mailing address:</strong> {POLICY_ADDRESS}</p>
    </PolicyPage>
  );
}

export default Delivery;
